import { deepMerge } from 'js/utils/Utils'

import BaseWebgl from 'js/webgl/BaseWebgl'
import Stage from 'js/webgl/base/Stage'

// pages
import HomeWebgl from 'js/webgl/pages/HomeWebgl'
import BusinessSingleWebgl from 'js/webgl/pages/BusinessSingleWebgl'
import CompanyWebgl from 'js/webgl/pages/CompanyWebgl'
import TeamsWebgl from 'js/webgl/pages/TeamsWebgl'
import NewsHomeWebgl from 'js/webgl/pages/NewsHomeWebgl'
import NewsSingleWebgl from 'js/webgl/pages/NewsSingleWebgl'
import CareerHomeWebgl from 'js/webgl/pages/CareerHomeWebgl'
import ContactWebgl from 'js/webgl/pages/ContactWebgl'

const defaults = {
  instanceName: 'webgl',
}

export default class Webgl extends BaseWebgl {
  homeWebgl = null
  businessSingleWebgl = null
  companyWebgl = null
  newsHomeWebgl = null
  newsSingleWebgl = null
  careerHomeWebgl = null
  teamsWebgl = null
  contactWebgl = null

  constructor(options = {}) {
    super()
    this.scroll = 0
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  _setStage() {
    if (this.$canvas) {
      this.stage = new Stage({
        $canvasContainer: this.$canvasContainer,
        $canvas: this.$canvas,
        rendererColor: {
          color: 0xf1f1f1,
          alpha: 1,
        },
      })

      if (this.stage) {
        this.stage.init()
      }
    }
  }

  addHandlers() {
    super.addHandlers()
  }

  removeHandlers() {
    super.removeHandlers()
  }

  enter({ pageId, $contentRoot, viewController }) {
    const options = {
      $contentRoot,
      viewController,
      webgl: this,
    }

    switch (pageId) {
      case 'Home': {
        this.homeWebgl = new HomeWebgl(options)
        this.homeWebgl.init()
        break
      }

      case 'BusinessSingle':
      case 'BusinessManagement':
      case 'BusinessMerchandise':
      case 'BusinessContentsProduction':
      case 'BusinessMarketing': {
        this.businessSingleWebgl = new BusinessSingleWebgl(options)
        this.businessSingleWebgl.init()
        break
      }

      case 'Company': {
        this.companyWebgl = new CompanyWebgl(options)
        this.companyWebgl.init()

        break
      }

      case 'Staff': {
        this.teamsWebgl = new TeamsWebgl(options)
        this.teamsWebgl.init()
        break
      }

      case 'NewsHome': {
        this.newsHomeWebgl = new NewsHomeWebgl(options)
        this.newsHomeWebgl.init()
        break
      }

      case 'NewsSingle': {
        this.newsSingleWebgl = new NewsSingleWebgl(options)
        this.newsSingleWebgl.init()
        break
      }

      case 'CareerHome': {
        this.careerHomeWebgl = new CareerHomeWebgl(options)
        this.careerHomeWebgl.init()
        break
      }

      case 'Contact':
      case 'ContactHome': {
        this.contactWebgl = new ContactWebgl(options)
        this.contactWebgl.init()
        break
      }
    }
  }

  afterEnter({ pageId, $contentRoot, viewController }) {
    switch (pageId) {
      case 'Home':
    }
  }

  leave({ pageId }) {
    switch (pageId) {
      case 'Home': {
        if (this.homeWebgl) {
          this.homeWebgl.destroy()
          this.homeWebgl = null
        }
        break
      }

      case 'BusinessSingle':
      case 'BusinessManagement':
      case 'BusinessMerchandise':
      case 'BusinessContentsProduction':
      case 'BusinessMarketing': {
        if (this.businessSingleWebgl) {
          this.businessSingleWebgl.destroy()
          this.businessSingleWebgl = null
        }
        break
      }

      case 'Company': {
        if (this.companyWebgl) {
          this.companyWebgl.destroy()
          this.companyWebgl = null
        }
        break
      }

      case 'Staff': {
        if (this.teamsWebgl) {
          this.teamsWebgl.destroy()
          this.teamsWebgl = null
        }
        break
      }

      case 'NewsHome': {
        if (this.newsHomeWebgl) {
          this.newsHomeWebgl.destroy()
          this.newsHomeWebgl = null
        }
        break
      }

      case 'NewsSingle': {
        if (this.newsSingleWebgl) {
          this.newsSingleWebgl.destroy()
          this.newsSingleWebgl = null
        }
        break
      }

      case 'CareerHome': {
        if (this.careerHomeWebgl) {
          this.careerHomeWebgl.destroy()
          this.careerHomeWebgl = null
        }
        break
      }

      case 'Contact':
      case 'ContactHome': {
        if (this.contactWebgl) {
          this.contactWebgl.destroy()
          this.contactWebgl = null
        }
        break
      }
    }
  }

  fvAnimation({ pageId }) {
    switch (pageId) {
      case 'Home': {
        if (this.homeWebgl) {
          this.homeWebgl.fvAnimation()
        }
        break
      }

      case 'BusinessSingle':
      case 'BusinessManagement':
      case 'BusinessMerchandise':
      case 'BusinessContentsProduction':
      case 'BusinessMarketing': {
        if (this.businessSingleWebgl) {
          this.businessSingleWebgl.fvAnimation()
        }
        break
      }

      case 'Company': {
        if (this.companyWebgl) {
          this.companyWebgl.fvAnimation()
        }
        break
      }

      case 'Staff': {
        if (this.teamsWebgl) {
          this.teamsWebgl.fvAnimation()
        }
        break
      }

      case 'NewsHome': {
        if (this.newsHomeWebgl) {
          this.newsHomeWebgl.fvAnimation()
        }
        break
      }

      case 'NewsSingle': {
        if (this.newsSingleWebgl) {
          this.newsSingleWebgl.fvAnimation()
        }
        break
      }

      case 'CareerHome': {
        if (this.careerHomeWebgl) {
          this.careerHomeWebgl.fvAnimation()
        }
        break
      }

      case 'Contact':
      case 'ContactHome': {
        if (this.contactWebgl) {
          this.contactWebgl.fvAnimation()
        }
        break
      }
    }
  }

  onResize() {
    requestAnimationFrame(() => {
      super.onResize()

      if (this.homeWebgl) {
        this.homeWebgl.onResize()
      }
      if (this.businessSingleWebgl) {
        this.businessSingleWebgl.onResize()
      }
      if (this.companyWebgl) {
        this.companyWebgl.onResize()
      }
      if (this.teamsWebgl) {
        this.teamsWebgl.onResize()
      }
      if (this.newsHomeWebgl) {
        this.newsHomeWebgl.onResize()
      }
      if (this.newsSingleWebgl) {
        this.newsSingleWebgl.onResize()
      }
      if (this.careerHomeWebgl) {
        this.careerHomeWebgl.onResize()
      }
      if (this.contactWebgl) {
        this.contactWebgl.onResize()
      }
    })
  }

  onRaf = (timeStamp) => {
    if (!this.scroll) {
      this.scroll = 0
    }

    if (this.homeWebgl) {
      this.homeWebgl.onRaf()
    }
    if (this.businessSingleWebgl) {
      this.businessSingleWebgl.onRaf()
    }
    if (this.companyWebgl) {
      this.companyWebgl.onRaf()
    }
    if (this.teamsWebgl) {
      this.teamsWebgl.onRaf()
    }
    if (this.newsHomeWebgl) {
      this.newsHomeWebgl.onRaf()
    }
    if (this.newsSingleWebgl) {
      this.newsSingleWebgl.onRaf()
    }
    if (this.careerHomeWebgl) {
      this.careerHomeWebgl.onRaf()
    }
    if (this.contactWebgl) {
      this.contactWebgl.onRaf()
    }

    super.onRaf(timeStamp)
  }
}